import { Injectable } from '@angular/core';

@Injectable()
export class LoadService {
    isFirstLoad = true;
}


// WEBPACK FOOTER //
// ./src/app/mega-menu/load-service.ts